import {Component, computed, effect, inject, resource, signal, Signal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {DatePipe} from "@angular/common";
import {orderBy} from "../../../shared/util/orderBy";
import {FormsModule} from "@angular/forms";
import {RouterLink} from "@angular/router";
import {v4 as uuid} from "uuid";
import {authStore} from "../../../core/service/auth/auth.store";
import {TranslatePipe} from "@ngx-translate/core";
import {QuotationFormComponent} from "../../../shared/modals/quotation-form/quotation-form.component";
import {MatDialog} from "@angular/material/dialog";
import {translate} from "../../../shared/translate/translate";
import {LoaderElementComponent} from "../../../shared/loader-element/loader-element.component";
import {ProjectRecord} from "../../../shared/types/project-record.type";
import {MessageViewComponent} from "../../../shared/modals/message-view/message-view.component";

@Component({
  selector: 'app-project-listing',
  imports: [
    DatePipe,
    FormsModule,
    RouterLink,
    TranslatePipe,
    LoaderElementComponent
  ],
  templateUrl: './project-listing.component.html',
  styleUrl: './project-listing.component.scss',
  standalone: true
})
export class ProjectListingComponent {
  private http: HttpClient = inject(HttpClient);
  private auth = inject(authStore);
  private dialog = inject(MatDialog);
  protected readonly user = inject(authStore).loggedInUser;

  employeeAuthority = computed(() => this.auth.hasAuthority("ROLE_EMPLOYEE"));

  resourceState = signal(uuid())

  projectResource = resource({
    request: this.resourceState,
    loader: ()=> new Promise((resolve) => this.http.get("/api/project").subscribe(resolve)),
  })

  projects: Signal<any[]> = computed(()=> (this.projectResource.hasValue() && orderBy(this.projectResource.value() as Array<any>, "modifiedAt")) || []);

  searchTerm = signal("");

  filteredProjects: Signal<any[]> = computed(() => (this.projects() && this.projects()?.filter( project =>
      project.name.toLowerCase().includes(this.searchTerm().toLowerCase()) ||
      project.id.includes(this.searchTerm().toLowerCase())
  )));

  lastRecordDates = computed(()=>this.filteredProjects().map(project=> orderBy(project.projectRecords, 'createdAt', 'desc')[0].createdAt));
  lastRecord = computed(()=>this.filteredProjects().map(project=> orderBy<any>(project.projectRecords, 'createdAt', 'desc')[0]));

  onDeleteKey = translate("DASHBOARD.PROJECT_LISTING.DELETE_KEY");

  onDeleteProject(id: string){
    if(confirm(this.onDeleteKey())) {
      this.http.delete(`/api/project/${id}`).subscribe(() => this.resourceState.set(uuid()));
    }
  }

  onQuotation( name: string, projectRecord: ProjectRecord){
    this.dialog.open(QuotationFormComponent, {
      data: { projectName: name, projectRecordId: projectRecord.id, projectRecordName: projectRecord.name },
      minWidth: '40vw',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '300ms',
    }).afterClosed()
    .subscribe((data: Promise<boolean>)=>{

      if(!data) { return }

      const loaderSignal = signal(true);
      data?.then(()=> loaderSignal.set(false));

      this.dialog.open(LoaderElementComponent, { data: {
          labelKey: "GLOBAL.LOADING",
          loading: loaderSignal
      },
        enterAnimationDuration: '500ms',
        exitAnimationDuration: '500ms',
        disableClose: true,

      }).afterClosed().subscribe(()=> {
        if (loaderSignal()) { return }

        this.dialog.open(MessageViewComponent, {
          data: {
            translate: true,
            message: "QUOTATION.QUOTATION_SUCCESS_MESSAGE",
          },
          enterAnimationDuration: '300ms',
          exitAnimationDuration: '300ms',
        })
      })

      new Promise(()=>setTimeout(()=>{ if(!data){ loaderSignal.set(false); }},1000))
    });
  }
}
